module.exports = __webpack_public_path__ + "onboarding-good.5c88ba46cae38311c3ef8d29533c0a8d.hashedasset.png";